<template>
  <div class="top_black_block" :style="backgroundStyle">
    <div class="tip_swiper">
      <div class="tip_transform" :style="scrollContentStyle">
        <div v-for="(item, index) in noticeData.list" :key="'item-' + index" class="scroll-item other-style"
          :style="[getScrollItemStyle(index)]">
          <a :href="item.link" target="_blank"><span>{{ item.content }}</span></a>
        </div>
        <div v-if="noticeData.list && noticeData.list.length > 1" class="scroll-item scroll-item-first other-style"
          :style="[getScrollItemStyle(0)]">
          <a :href="noticeData.list[0].link ? noticeData.list[0].link : ''" target="_blank"><span>{{
            noticeData.list[0].content }}</span></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationBar",
  props: {
    notice: {},
    getIsMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      scrollTimeout: null,
      scrollTimeout2: null,
      // scrollSpeedX: 20,
      scrollSpeedYTotal: 5,
      scrollPreStopYTime: 1,
      // scrollSpeedY: 5, 停留时长
      scrollAfterStopXTime: 0.3,
      scrollTransY: 0.4,
      scrollContentRect: {},
      scrollContentStyle: {
        transform: "",
        transition: "",
      },
      scrollItemRect: [],
      scrollItemStyle: [],
    };
  },
  methods: {
    // 安全获取滚动项样式
    getScrollItemStyle(index) {
      try {
        if (this.scrollItemStyle && Array.isArray(this.scrollItemStyle) && this.scrollItemStyle[index]) {
          return this.scrollItemStyle[index];
        }
        return {};
      } catch (e) {
        return {};
      }
    },

    clearScrollInterval() {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
      if (this.scrollTimeout2) clearTimeout(this.scrollTimeout2);
      this.scrollTimeout = null;
      this.scrollTimeout2 = null;
    },

    initAnimation() {
      // 确保数据存在
      if (!this.noticeData.list || !Array.isArray(this.noticeData.list) || this.noticeData.list.length === 0) {
        return;
      }

      this.$nextTick(() => {
        try {
          const res = document.querySelectorAll(".scroll-item");
          if (res && res.length) {
            this.scrollItemRect = Array.from(res).map((i) => ({
              width: i.clientWidth || 0,
              height: i.clientHeight || 0,
            }));
          }

          const res2 = document.querySelector(".tip_transform");
          if (res2) {
            this.scrollContentRect = {
              width: res2.clientWidth || 0,
              height: res2.clientHeight || 0,
            };
          }

          this.setScrollAnimation();
        } catch (error) {
          console.warn('初始化动画时出错:', error);
        }
      });
    },

    setScrollAnimation() {
      if (!this.scrollItemRect ||
        !Array.isArray(this.scrollItemRect) ||
        this.scrollItemRect.length === 0 ||
        !this.scrollItemRect[0] ||
        !this.scrollItemRect[0].height) {
        setTimeout(() => {
          this.initAnimation();
        }, 300);
        return;
      }

      this.clearScrollInterval();
      this.scrollItemAction(0);
    },

    scrollItemAction(index) {
      // 添加更多安全检查
      if (!this.scrollItemRect ||
        !this.noticeData.list ||
        index >= this.scrollItemRect.length ||
        index >= this.noticeData.list.length ||
        !this.scrollItemRect[index]) {
        return;
      }

      const { width, height } = this.scrollItemRect[index];
      const { width: contentWidth } = this.scrollContentRect;
      const isNeedScrollX = width > contentWidth;
      const isMulti = this.noticeData.list.length > 1;

      let scrollTime = isNeedScrollX
        ? (width / contentWidth) * this.scrollSpeedX
        : this.scrollSpeedY;

      if (isNeedScrollX) {
        setTimeout(() => {
          this._setScrollItemStyle(index, {
            transition: `transform ${scrollTime}s linear`,
            transform: `translateX(${-1 * width}px)`,
          });
        }, this.scrollPreStopYTime * 1000);
      }

      this.scrollTimeout = setTimeout(() => {
        if (isMulti) {
          this.scrollContentStyle = {
            transition: `transform ${this.scrollTransY}s ease-out`,
            transform: `translateY(${-1 * (index + 1) * height}px)`,
          };

          this.scrollTimeout2 = setTimeout(() => {
            this._setScrollItemStyle(index, {
              transition: "none",
              transform: "none",
            });

            let nextIndex = index + 1;
            if (nextIndex >= this.noticeData.list.length) {
              nextIndex = 0;
              this.scrollContentStyle = {
                transition: "none",
                transform: "none",
              };
            }
            this.scrollItemAction(nextIndex);
          }, this.scrollTransY * 1000);
        } else if (isNeedScrollX) {
          scrollTime = ((contentWidth + width) / contentWidth) * this.scrollSpeedX;

          const raf = () => {
            this._setScrollItemStyle(index, {
              transition: "none",
              transform: `translateX(${contentWidth}px)`,
            });

            this.scrollTimeout = setTimeout(() => {
              this._setScrollItemStyle(index, {
                transition: `transform ${scrollTime}s linear`,
                transform: `translateX(${-1 * width}px)`,
              });
            }, this.scrollAfterStopXTime * 1000);

            this.scrollTimeout2 = setTimeout(
              raf,
              (scrollTime + this.scrollAfterStopXTime) * 1000
            );
          };
          raf();
        }
      }, (scrollTime + this.scrollPreStopYTime) * 1000);
    },

    _setScrollItemStyle(index, item) {
      try {
        // 确保数组长度足够
        while (this.scrollItemStyle.length <= index) {
          this.$set(this.scrollItemStyle, this.scrollItemStyle.length, {});
        }
        this.$set(this.scrollItemStyle, index, item);
      } catch (e) {
        console.warn('设置滚动项样式时出错:', e);
      }
    },

    openLanguageModal() {
      this.$emit("openLanguageModal");
    },
  },

  mounted() {
    // 延迟执行确保DOM完全加载
    this.$nextTick(() => {
      setTimeout(() => {
        this.initAnimation();
      }, 100);
    });
  },

  beforeDestroy() {
    this.clearScrollInterval();
  },

  // 添加错误处理
  errorCaptured(err, vm, info) {
    console.error('NotificationBar组件错误:', err, info);
    return false;
  },

  computed: {
    noticeData() {
      return this.notice || { list: [] };
    },

    // 背景样式
    backgroundStyle() {
      return {
        '--background-color': this.noticeData.background_color || '#212322',
        '--text-color': this.noticeData.text_color || '#fff',
        '--font-size': this.noticeData.font_size + 'px' || '12px',
      };
    },

    // 滚动速度
    scrollSpeedY() {
      return this.noticeData.interval || 5;
    },
    scrollSpeedX() {
      const noticeDataScroll_speed_x = this.noticeData.scroll_speed_x || 20;
      if (this.getIsMobile || window.innerWidth < 1024) {
        return (noticeDataScroll_speed_x / 2)
      }
      return noticeDataScroll_speed_x
    },

    // 显示模式
    displayMode() {
      return this.noticeData.display_mode || 'down';
    }
  },
};
</script>

<style lang="scss" scoped>
.top_black_block {
  display: flex;
  z-index: 1001;
  width: 100%;
  background: var(--background-color, #212322);

  // border: 1px solid transparent;
  /* 使用borderColor */
}

.tip_swiper {
  height: 30px;
  width: 100%;
  overflow: hidden;
  position: relative;
  margin: auto;
  max-width: 1154px;

  box-sizing: border-box;


  .tip_transform {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}

.other-style {
  text-indent: 12px;
}

.scroll-item {
  text-align: center;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  box-sizing: border-box;
  white-space: nowrap;
  width: fit-content;
  min-width: 100%;
  cursor: pointer;
  font-size: var(--font-size, 12px);
  color: var(--text-color, #fff);


  a {
    color: #fff;
    display: block;
    width: 100%;
    font-size: var(--font-size, 12px);
    font-family: "Noto Sans CJK SC";
    font-style: normal;
    text-transform: uppercase;

    span {
      color: var(--text-color, #fff);
      font-size: var(--font-size, 12px);
      font-family: "Noto Sans CJK SC";
      font-style: normal;
      text-transform: uppercase;
    }

    :link {
      color: #fff;
      text-decoration: none;
    }

    :visited {
      color: #fff;
      text-decoration: none;
    }

    :hover {
      color: #fff;
      text-decoration: none;
    }

    :active {
      color: #fff;
    }
  }

  a::after {
    color: #fff;
  }
}

@media only screen and (max-width: 1024px) {
  .tip_swiper {
    height: 30px;
    overflow: hidden;
    position: relative;
    margin-right: 20px;
    margin-left: 20px;

    .tip_transform {
      width: 100%;
      position: absolute;
      margin: auto;

      left: 0;
      top: 0;
    }
  }
}
</style>